"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
const react_1 = require("react");
const _1 = require(".");
function useIsMobile(width = 600) {
    const { width: currentWidth } = (0, _1.useWindowSize)();
    const [isMobile, setIsMobile] = (0, react_1.useState)(() => currentWidth < width);
    (0, react_1.useEffect)(() => setIsMobile(() => currentWidth < width), [currentWidth, width]);
    return isMobile;
}
exports.useIsMobile = useIsMobile;
